'use client';

import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { useState } from 'react';

const links = [
  { href: '/',         label: '❤️ Home' },
  { href: '/trending', label: '🔥 Trending' },
  { href: '/vs',       label: '⚔️ VS',  alwaysYellow: true },
  { href: '/abroad',   label: '✈️ Abroad' },
  { href: '/blog',     label: '📜 Blog' },
  { href: '/faq',      label: '❓ FAQ' },
  { href: '/contact',  label: '💌 Contact' },
];

export default function NavLinks() {
  const pathname = usePathname();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      {/* Desktop nav */}
      <nav className="hidden sm:flex gap-6 text-sm font-medium text-slate-300 items-center">
        {links.map(({ href, label, alwaysYellow }) => {
          const active = href === '/' ? pathname === '/' : pathname.startsWith(href);
          return (
            <Link
              key={href}
              href={href}
              onClick={href === '/' && pathname === '/' ? (e) => { e.preventDefault(); window.location.assign('/'); } : undefined}
              className={`transition-colors hover:text-amber-300 ${alwaysYellow ? 'text-amber-500/80 font-bold' : ''} ${active ? 'underline decoration-amber-400 decoration-2 underline-offset-4' : ''}`}
            >
              {label}
            </Link>
          );
        })}
      </nav>

      {/* Mobile hamburger button */}
      <button
        className="sm:hidden text-slate-300 hover:text-white text-2xl leading-none transition-colors p-1"
        onClick={() => setIsOpen(!isOpen)}
        aria-label="Toggle menu"
      >
        {isOpen ? '✕' : '☰'}
      </button>

      {/* Mobile dropdown */}
      {isOpen && (
        <div className="sm:hidden fixed inset-x-0 top-20 bg-[#07111e]/97 backdrop-blur-md border-b border-amber-500/20 z-40 flex flex-col py-3 px-6">
          {links.map(({ href, label, alwaysYellow }) => {
            const active = href === '/' ? pathname === '/' : pathname.startsWith(href);
            return (
              <Link
                key={href}
                href={href}
                onClick={href === '/' && pathname === '/'
                  ? (e) => { e.preventDefault(); setIsOpen(false); window.location.assign('/'); }
                  : () => setIsOpen(false)}
                className={`py-3 text-base font-medium border-b border-slate-800 last:border-0 transition-colors hover:text-amber-300 ${alwaysYellow ? 'text-amber-500/80 font-bold' : 'text-slate-300'} ${active ? 'underline decoration-amber-400 decoration-2 underline-offset-4' : ''}`}
              >
                {label}
              </Link>
            );
          })}
        </div>
      )}
    </>
  );
}
